module.exports = __webpack_public_path__ + "static/media/S (18).a6c5a4bd.jpg";